<script lang="ts">
	import ProcessingButton from '$lib/util/ProcessingButton.svelte';
	import { toBN } from '$lib/util/util';
	import type { ethers } from 'ethers';
	import type { SCButtonTypes, AddFundsInsufficientBalanceStatus } from '../types';

	export let input: string = '';
	export let fundsAmount: ethers.BigNumber = toBN('0');
	export let validation: AddFundsInsufficientBalanceStatus = {
		isInsufficient: false,
		reason: ''
	};
	export let processing: boolean = false;
	export let execute: () => void;
	export let type: SCButtonTypes = 'Deposit';
	export let minDepositNeeded: string = '0';
</script>

{#if !input || input == '0'}
	<button
		class="mt-2 rounded-lg squircle-xl bg-fx-grey-600 py-4 text-fx-grey-300 font-semibold text-center cursor-pointer w-full disabled"
	>
		{type} Funds
	</button>
{:else if type === 'Deposit' && fundsAmount.lt(toBN(minDepositNeeded))}
	<button
		class="mt-2 rounded-lg squircle-xl bg-fx-grey-600 py-4 text-fx-grey-300 font-semibold text-center cursor-pointer w-full disabled"
	>
		Deposit Funds <span class="text-xs">(min. deposit ${minDepositNeeded})</span>
	</button>
{:else if validation.isInsufficient}
	<button
		class="mt-2 rounded-lg squircle-xl bg-fx-grey-600 py-4 text-fx-grey-300 font-semibold text-center cursor-pointer w-full disabled"
	>
		{validation.reason}
	</button>
{:else if processing && type === 'Deposit'}
	<div class="mt-2">
		<ProcessingButton title="Depositing" />
	</div>
{:else if processing && type === 'Withdraw'}
	<div class="mt-2">
		<ProcessingButton title="Withdrawing" />
	</div>
{:else}
	<button
		class="mt-2 rounded-lg squircle-xl bg-fx-gradient-9 py-4 text-fx-black font-semibold text-center cursor-pointer w-full"
		on:click={execute}
	>
		{type} Funds
	</button>
{/if}
